module.exports = __webpack_public_path__ + "octopus-works.eb4a54a483708c13a22df4f74aa9efa1.hashedasset.svg";